// commonFunctions.js

import humanizeDuration from "humanize-duration";
import {UAParser} from "ua-parser-js";

export const messageToBeOppendText = "To be opened in";
/**
 * Converts milliseconds into a human-readable format like "2Mo. 4D. 3Hrs. 15Min."
 * @param {number} total - The total duration in milliseconds.
 * @returns {string} - Formatted duration string.
 */
export const formatDuration = (total) => {
  return humanizeDuration(total, {
    units: ["mo", "d", "h", "m"],
    round: true,
    spacer: "",
    delimiter: " ",
    largest: 4,
    language: "custom-en",
    languages: {
      "custom-en": {
        mo: () => "Mo.",
        d: () => "Days",
        h: () => "Hrs.",
        m: () => "Min.",
      },
    },
  });
};
export const getDeviceDetails = () => {
  const parser = new UAParser();
  const result = parser.getResult();

  return {
    device: result.device.model || "Unknown",
    os: result.os.name + " " + result.os.version,
    browser: result.browser.name + " " + result.browser.version
  };
};
